// const baseurl = "http://localhost:8080/api/"
const baseurl = "https://api.jiabaili.shop/api/"


export default baseurl